/* PRAWS · Freeship gate: ventana intermedia antes del checkout.
 * Se abre al ir al pago si MIN <= total < THRESHOLD y recomienda productos
 * (afines en color/talla al carrito) que completan el envío gratis.
 * API: window.PAWS_FS_GATE(destination) -> abre la ventana o navega directo.
 */
(function () {
  'use strict';
  const root = document.getElementById('paws-fs-gate');
  const dataEl = document.getElementById('paws-fs-gate-data');
  if (!root || !dataEl) return;

  let DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.warn('[paws-fs] bad data', e); return; }
  const PRODUCTS = (DATA.products || []).filter((p) => p && p.variants && p.variants.some((v) => v.available));
  if (!PRODUCTS.length) return;

  const cartEl = document.getElementById('paws-cart');
  const THRESHOLD = (Number(cartEl && cartEl.dataset.shippingThreshold) || Number(root.dataset.threshold) || 59900) * 100; // cents
  const MIN = (Number(root.dataset.min) || 25000) * 100;
  const DOUBLE_GAP = (Number(root.dataset.doubleGap) || 25000) * 100;
  const SESSION_KEY = 'paws_fs_gate_dismissed';
  const VISIBLE = 4; // tarjetas visibles por fila antes de "Ver más opciones"
  const SHIP_VALUE = (Number(root.dataset.shipValue) || 0) * 100; // valor del envío que se ahorra al completar (centavos)
  // Ofertas especiales por reglas de carrito (ej. MD: RITUAL a $4.989 si el resto del carrito ≥ $45.000).
  // Formato data-offers: [{"handle":"ritual","price":4989,"minCartWithout":45000,"label":"Oferta lanzamiento"}]
  let OFFERS = [];
  try { OFFERS = JSON.parse(root.dataset.offers || '[]'); } catch (e) { OFFERS = []; }
  const SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL'];
  // Tiers del descuento automático "arma tu pack" (min productos:% off). Se leen de data-tiers del snippet.
  const TIERS = String(root.dataset.tiers || '3:4,4:7,5:10').split(',').map((t) => { const a = t.split(':'); return { min: Number(a[0]), pct: Number(a[1]) }; }).filter((t) => t.min > 0);

  const $ = (sel) => root.querySelector(sel);
  const titleEl = $('[data-fs-title]');
  const fillEl = $('[data-fs-fill]');
  const statusEl = $('[data-fs-status]');
  const bodyEl = $('[data-fs-body]');
  const kickerEl = $('[data-fs-kicker]');
  const bannerEl = $('[data-fs-banner]');
  const ctaEl = $('[data-fs-checkout]');
  const skipEl = $('[data-fs-skip]');

  const fetchRaw = () => window.__paws_original_fetch || window.fetch;
  const fmt = (cents) => '$' + Math.round(cents / 100).toLocaleString('es-CL').replace(/,/g, '.');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const isColor = (name) => /color/i.test(name || '');
  const isSize = (name) => /talla|tama|size/i.test(name || '');
  const sizeKey = (val) => {
    const m = String(val || '').toUpperCase().match(/^(XS|XL|S|M|L)\b/);
    return m ? m[1] : null;
  };
  const track = (action, extra) => {
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: 'paws_fs_gate', fs_action: action }, extra || {})); } catch (e) { /* noop */ }
  };
  // Cerrar / "no gracias" / llegar al checkout marcan la ventana como vista por DISMISS_DAYS (localStorage), no solo por sesión.
  const DISMISS_KEY = 'paws_fs_gate_dismissed_at';
  const DISMISS_DAYS = Number(root.dataset.dismissDays) || 30;
  /* Atribución: guarda lo que pasó en la ventana como atributo del carrito (viaja al pedido, sección
   * "Información adicional" del Admin). Prefijo "_" = oculto para el cliente. Una llamada por evento,
   * en segundo plano; antes de navegar se espera máx. 800 ms. */
  let attrLog = '';
  function logAttr(entry) {
    attrLog = (attrLog ? attrLog + ' | ' : '') + entry;
    const value = attrLog.slice(0, 250);
    const req = fetchRaw()('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _fs_gate: value } }),
    }).catch(() => null);
    return Promise.race([req, new Promise((res) => setTimeout(res, 800))]);
  }

  const dismissed = () => {
    try {
      const t = Number(localStorage.getItem(DISMISS_KEY) || 0);
      if (t && Date.now() - t < DISMISS_DAYS * 864e5) return true;
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) { return false; }
  };
  const setDismissed = () => {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now())); } catch (e) { /* noop */ }
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) { /* noop */ }
  };

  kickerEl.textContent = 'Envío gratis sobre ' + fmt(THRESHOLD);

  let state = { cart: null, destination: '/checkout', added: [], open: false, expanded: [] };

  /* ───────── afinidad con el carrito ───────── */
  function cartPreferences(cart) {
    const colors = {};
    let size = null;
    (cart.items || []).forEach((it) => {
      (it.options_with_values || []).forEach((o) => {
        // Pondera por valor de línea: ante empate manda el color del producto principal (ej. el arnés).
        if (isColor(o.name) && o.value) colors[o.value] = (colors[o.value] || 0) + (it.final_line_price || it.line_price || it.quantity);
        if (isSize(o.name) && !size) {
          const k = sizeKey(o.value);
          if (k) size = k;
        }
      });
    });
    const color = Object.keys(colors).sort((a, b) => colors[b] - colors[a])[0] || null;
    return { color, size };
  }

  function pickVariant(product, prefs) {
    const avail = product.variants.filter((v) => v.available);
    if (!avail.length) return null;
    const ci = product.options.findIndex(isColor);
    const si = product.options.findIndex(isSize);
    const wantIdx = prefs.size ? SIZE_ORDER.indexOf(prefs.size) : -1;
    const score = (v) => {
      let s = 0;
      if (ci >= 0 && prefs.color && v.options[ci] === prefs.color) s += 100;
      if (si >= 0 && wantIdx >= 0) {
        const k = sizeKey(v.options[si]);
        const d = k ? Math.abs(SIZE_ORDER.indexOf(k) - wantIdx) : 9;
        s += 10 - d * 2 - (k && SIZE_ORDER.indexOf(k) < wantIdx ? 1 : 0); // misma talla > una más grande > una más chica
      }
      return s;
    };
    return avail.slice().sort((a, b) => score(b) - score(a))[0];
  }

  /* ───────── selección de candidatos ─────────
   * Praws tiene descuentos automáticos progresivos por cantidad (arma tu pack):
   * al agregar el 3er/4to/5to producto TODO el carrito baja 4/7/10 %. Por eso se
   * proyecta el total post-agregado y se exige que el precio de lista del
   * producto cubra la brecha "efectiva" (umbral / ratio − total original).
   */
  function tierPct(count) {
    let pct = 0;
    TIERS.forEach((t) => { if (count >= t.min) pct = Math.max(pct, t.pct); });
    return pct;
  }
  function tierRatio(count) { return 1 - tierPct(count) / 100; }

  /* Descuento que verá el cliente al agregar este producto (precio de línea real del checkout)
   * + ahorro total del pedido si con este producto se activa/sube el tier del pack. */
  function dealFor(price, plan, offer) {
    if (offer) {
      // Oferta especial: el precio ya viene rebajado por su propia regla (no se suma el % del pack).
      const completes = plan.mode === 'single' && (plan.total + offer.price) >= THRESHOLD;
      const shipSave = completes ? SHIP_VALUE : 0;
      return { pct: Math.round((1 - offer.price / price) * 100), disc: offer.price, upgrade: false, offer: true,
               label: offer.label, savings: (price - offer.price) + shipSave, shipSave, count: plan.count + 1 };
    }
    const pct = tierPct(plan.count + 1);
    // ¿Este producto solo completa el envío gratis? (solo en modo 1 fila)
    const completes = plan.mode === 'single' && price >= plan.effGap1;
    if (!pct && !completes) return null;
    const disc = pct ? Math.round(price * (1 - pct / 100)) : price;
    const packSave = pct ? Math.max(0, Math.round((plan.orig + price) * pct / 100) - plan.curDiscount) : 0;
    const shipSave = completes ? SHIP_VALUE : 0;
    return { pct, disc, upgrade: pct > plan.curPct, savings: packSave + shipSave, shipSave, count: plan.count + 1 };
  }
  function priceHTML(price, deal) {
    if (!deal || !deal.pct) return fmt(price);
    return '<s class="paws-fs__strike">' + fmt(price) + '</s> ' + fmt(deal.disc) + ' <span class="paws-fs__tag">-' + deal.pct + '%</span>';
  }
  // Una sola línea por tarjeta: cuánto ahorra con este producto y por qué (pack / envío).
  function dealHTML(deal) {
    if (!deal || !deal.savings) return '';
    const why = [];
    if (deal.offer) why.push(deal.label); else if (deal.pct) why.push('-' + deal.pct + '% pack ' + deal.count + ' productos');
    if (deal.shipSave) why.push('envío gratis');
    return '<span class="paws-fs__deal-save">Ahorras <b>' + fmt(deal.savings) + '</b> total</span>' +
           (why.length ? '<span class="paws-fs__deal-why">' + esc(why.join(' + ')) + '</span>' : '');
  }
  function offerFor(product, cart) {
    const o = OFFERS.find((x) => x.handle === product.handle);
    if (!o) return null;
    const without = (cart.items || []).reduce((sum, it) => sum + (it.product_id === product.id ? 0 : (it.final_line_price || it.line_price || 0)), 0);
    if (without < (Number(o.minCartWithout) || 0) * 100) return null;
    return { price: Math.round(Number(o.price) * 100), label: o.label || 'Oferta' };
  }

  function buildPlan(cart) {
    const total = cart.total_price || 0;
    const gap = THRESHOLD - total;
    const orig = cart.original_total_price || cart.items_subtotal_price || total;
    const curRatio = orig > 0 ? Math.min(1, total / orig) : 1;
    const count = cart.item_count || 0;
    const ratioAfter = (k) => Math.min(curRatio, tierRatio(count + k));
    const effGap = (k) => Math.ceil(THRESHOLD / ratioAfter(k)) - orig; // en precio de lista (centavos)
    const inCart = new Set((cart.items || []).map((it) => it.product_id));
    const prefs = cartPreferences(cart);
    const pool = PRODUCTS.filter((p) => !inCart.has(p.id)).map((p) => {
      const v = pickVariant(p, prefs);
      const offer = v ? offerFor(p, cart) : null;
      return { p, v, offer, min: v ? (offer ? offer.price : v.price) : Infinity, role: offer ? (offer.price <= 1200000 ? 'low' : 'big') : p.role };
    }).filter((c) => c.v);
    const byPriceThenPriority = (a, b) => (a.min - b.min) || (a.p.priority - b.p.priority);
    const base = { gap, total, effGap1: effGap(1), ratio1: ratioAfter(1), count, orig, curDiscount: Math.max(0, orig - total), curPct: tierPct(count) };

    if (gap <= 0) return Object.assign(base, { mode: 'reached', rows: [] });

    if (gap > DOUBLE_GAP) {
      const need2 = effGap(2);
      const lows = pool.filter((c) => c.role === 'low').sort((a, b) => a.p.priority - b.p.priority);
      const maxLow = lows.length ? Math.max.apply(null, lows.map((c) => c.min)) : 0;
      let bigs = pool.filter((c) => c.role === 'big' && c.min + maxLow >= need2).sort(byPriceThenPriority);
      if (!bigs.length) bigs = pool.filter((c) => c.role === 'big').sort((a, b) => b.min - a.min);
      if (bigs.length && lows.length) {
        const restBigs = pool.filter((c) => c.role === 'big' && bigs.indexOf(c) < 0).sort((a, b) => b.min - a.min);
        return Object.assign(base, { mode: 'double', rows: [
          { title: 'Elige 1 de estos', items: bigs.concat(restBigs), primary: bigs.length },
          { title: '+ 1 de estos', items: lows, primary: lows.length },
        ] });
      }
    }
    const need1 = effGap(1);
    const reaches = (c) => c.offer ? (total + c.min >= THRESHOLD) : c.min >= need1; // ofertas: precio ya rebajado, sin % pack
    const singles = pool.filter(reaches).sort(byPriceThenPriority);
    const extras = pool.filter((c) => !reaches(c)).sort((a, b) => b.min - a.min); // no alcanzan solos: van al "ver más"
    return Object.assign(base, { mode: 'single', rows: [{ title: null, items: singles.concat(extras), primary: singles.length }] });
  }

  /* ───────── render ───────── */
  function renderHeader(plan) {
    const pct = Math.max(4, Math.min(100, (plan.total / THRESHOLD) * 100));
    fillEl.style.width = pct + '%';
    root.classList.toggle('paws-fs--reached', plan.mode === 'reached');
    if (plan.mode === 'reached') {
      titleEl.textContent = '¡Listo! Tienes envío gratis, vamos al pago…';
      statusEl.textContent = 'Total ' + fmt(plan.total) + ' · envío gratis incluido';
      ctaEl.textContent = 'Ir al pago con envío gratis';
    } else {
      titleEl.textContent = plan.mode === 'double'
        ? 'Lleva 1 de cada fila y consigue envío gratis'
        : 'Agrega 1 de estos y consigue envío gratis';
      statusEl.textContent = 'Te faltan ' + fmt(plan.gap) + ' para el envío gratis';
      ctaEl.textContent = 'Ir al pago';
    }
  }

  function cardHTML(c, plan) {
    const p = c.p, v = c.v;
    const short = plan && plan.mode === 'single' ? (c.offer ? (THRESHOLD - plan.total - c.offer.price) : plan.effGap1 - v.price) : 0;
    const note = short > 0 ? 'Con esta opción aún faltan ' + fmt(Math.round(short * plan.ratio1)) : '';
    const deal = plan ? dealFor(v.price, plan, c.offer) : null;
    const selects = p.options.map((name, i) => {
      const vals = [];
      p.variants.forEach((vv) => { if (vals.indexOf(vv.options[i]) < 0) vals.push(vv.options[i]); });
      if (vals.length < 2) return '';
      const opts = vals.map((val) => {
        const anyAvail = p.variants.some((vv) => vv.available && vv.options[i] === val);
        return '<option value="' + esc(val) + '"' + (val === v.options[i] ? ' selected' : '') + (anyAvail ? '' : ' disabled') + '>' + esc(val) + (anyAvail ? '' : ' · agotado') + '</option>';
      }).join('');
      return '<select class="paws-fs__sel" data-fs-opt="' + i + '" aria-label="' + esc(name) + '">' + opts + '</select>';
    }).join('');
    return '<div class="paws-fs__card" data-fs-card data-product-id="' + p.id + '">' +
      '<a class="paws-fs__img" href="' + esc(p.url) + '" target="_blank" rel="noopener"><img src="' + esc(v.image) + '" alt="' + esc(p.title) + '" loading="lazy" data-fs-img></a>' +
      '<p class="paws-fs__name">' + esc(p.title) + '</p>' +
      '<p class="paws-fs__price" data-fs-price>' + priceHTML(v.price, deal) + '</p>' +
      '<div class="paws-fs__deal" data-fs-deal>' + dealHTML(deal) + '</div>' +
      selects +
      '<p class="paws-fs__note" data-fs-note>' + esc(note) + '</p>' +
      '<button type="button" class="paws-fs__add" data-fs-add data-variant-id="' + v.id + '">Agregar</button>' +
      '</div>';
  }

  function renderBody(plan) {
    if (plan.mode === 'reached') {
      bodyEl.innerHTML = state.added.length
        ? '<p class="paws-fs__added">✓ Agregado: ' + esc(state.added.join(', ')) + '</p>'
        : '';
      return;
    }
    if (!plan.rows.length || !plan.rows.every((r) => r.items.length)) {
      bodyEl.innerHTML = '<p class="paws-fs__empty">No encontramos productos para completar tu envío gratis ahora.</p>';
      return;
    }
    bodyEl.innerHTML = plan.rows.map((row, ri) => {
      const expanded = state.expanded.indexOf(ri) >= 0;
      // Visibles: solo los que garantizan el envío gratis (hasta VISIBLE); el resto va detrás de "Ver más opciones".
      const limit = row.primary > 0 ? Math.min(VISIBLE, row.primary) : VISIBLE;
      const shown = expanded ? row.items : row.items.slice(0, limit);
      const hidden = row.items.length - shown.length;
      return '<div class="paws-fs__row">' + (row.title ? '<p class="paws-fs__row-title">' + esc(row.title) + '</p>' : '') +
        '<div class="paws-fs__grid">' + shown.map((c) => cardHTML(c, plan)).join('') + '</div>' +
        (hidden > 0 ? '<button type="button" class="paws-fs__more" data-fs-more="' + ri + '">Ver más opciones (' + hidden + ')</button>' : '') +
        '</div>';
    }).join('') + (state.added.length ? '<p class="paws-fs__added">✓ Agregado: ' + esc(state.added.join(', ')) + '</p>' : '');
    bindCards(plan);
    bodyEl.querySelectorAll('[data-fs-more]').forEach((b) => b.addEventListener('click', () => {
      state.expanded.push(Number(b.dataset.fsMore));
      track('more', { fs_row: Number(b.dataset.fsMore) });
      renderBody(plan);
    }));
  }

  function bindCards(plan) {
    bodyEl.querySelectorAll('[data-fs-card]').forEach((card) => {
      const pid = Number(card.dataset.productId);
      const p = PRODUCTS.find((x) => x.id === pid);
      if (!p) return;
      const cand = plan.rows.reduce((f, r) => f || r.items.find((c) => c.p.id === pid), null);
      const selects = Array.from(card.querySelectorAll('[data-fs-opt]'));
      const btn = card.querySelector('[data-fs-add]');
      const img = card.querySelector('[data-fs-img]');
      const priceEl = card.querySelector('[data-fs-price]');
      const noteEl = card.querySelector('[data-fs-note]');
      const dealEl = card.querySelector('[data-fs-deal]');

      const currentSel = () => p.options.map((_, i) => {
        const s = selects.find((el) => Number(el.dataset.fsOpt) === i);
        return s ? s.value : null;
      });
      const findVariant = (sel) => p.variants.find((vv) => sel.every((val, i) => val == null || vv.options[i] === val));

      const applyVariant = (vv) => {
        if (!vv) { btn.disabled = true; btn.textContent = 'Agotado'; noteEl.textContent = ''; return; }
        selects.forEach((s) => { s.value = vv.options[Number(s.dataset.fsOpt)]; });
        if (img && vv.image && img.getAttribute('src') !== vv.image) { img.style.opacity = '0.4'; img.src = vv.image; img.onload = () => { img.style.opacity = '1'; }; }
        const deal = dealFor(vv.price, plan, cand && cand.offer);
        priceEl.innerHTML = priceHTML(vv.price, deal);
        if (dealEl) dealEl.innerHTML = dealHTML(deal);
        btn.dataset.variantId = vv.id;
        btn.disabled = !vv.available;
        btn.textContent = vv.available ? 'Agregar' : 'Agotado';
        const short = cand && cand.offer ? (THRESHOLD - plan.total - cand.offer.price) : plan.effGap1 - vv.price; // en precio de lista
        noteEl.textContent = (vv.available && plan.mode === 'single' && short > 0) ? 'Con esta opción aún faltan ' + fmt(Math.round(short * plan.ratio1)) : '';
      };

      selects.forEach((s) => {
        s.addEventListener('change', () => {
          const i = Number(s.dataset.fsOpt);
          const sel = currentSel();
          let vv = findVariant(sel);
          if (!vv || !vv.available) {
            // Reajusta las otras opciones a la primera combinación disponible con este valor.
            const alt = p.variants.find((x) => x.available && x.options[i] === sel[i]);
            if (alt) vv = alt;
          }
          applyVariant(vv);
        });
      });

      btn.addEventListener('click', () => addVariant(btn, p));
    });
  }

  async function addVariant(btn, product) {
    if (btn.disabled) return;
    const variantId = Number(btn.dataset.variantId);
    btn.disabled = true;
    const old = btn.textContent;
    btn.textContent = 'Agregando…';
    try {
      const res = await fetchRaw()('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('add ' + res.status);
      state.added.push(product.title);
      track('add', { fs_product: product.handle, fs_variant: variantId });
      logAttr('agregó ' + product.handle);
      if (typeof window.PAWS_CART_UPDATE === 'function') window.PAWS_CART_UPDATE();
      const cart = await getCart();
      state.cart = cart;
      const plan = buildPlan(cart);
      if (plan.mode === 'reached') {
        // Apenas se logra el envío gratis: directo al checkout, sin pantalla intermedia.
        track('reached', { fs_total: Math.round(plan.total / 100), fs_added: state.added.length });
        setDismissed();
        btn.textContent = 'Listo, vamos al pago…';
        logAttr('logró envío gratis $' + Math.round(plan.total / 100)).then(() => go(state.destination));
        return;
      }
      state.expanded = []; // el plan cambió: vuelve a mostrar solo los que garantizan el envío gratis
      renderHeader(plan);
      renderBody(plan);
    } catch (e) {
      console.error('[paws-fs] add failed', e);
      btn.disabled = false;
      btn.textContent = old;
      const note = btn.parentNode.querySelector('[data-fs-note]');
      if (note) note.textContent = 'No se pudo agregar, intenta de nuevo';
    }
  }

  async function getCart() {
    const res = await fetchRaw()('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!res.ok) throw new Error('cart ' + res.status);
    return res.json();
  }

  /* ───────── abrir / cerrar ───────── */
  function openModal(cart, plan, destination) {
    state = { cart, destination: destination || '/checkout', added: [], open: true, expanded: [] };
    ctaEl.setAttribute('href', state.destination);
    skipEl.setAttribute('href', state.destination);
    renderHeader(plan);
    renderBody(plan);
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('paws-fs-open');
    if (typeof window.PAWS_CART_CLOSE === 'function') { try { window.PAWS_CART_CLOSE(); } catch (e) { /* noop */ } }
    track('open', { fs_mode: plan.mode, fs_gap: Math.round(plan.gap / 100), fs_total: Math.round(plan.total / 100) });
    attrLog = '';
    logAttr('abrió ' + (plan.mode === 'double' ? '2 filas' : '1 fila') + ' faltaban $' + Math.round(plan.gap / 100));
    setTimeout(() => { try { ctaEl.focus({ preventScroll: true }); } catch (e) { /* noop */ } }, 50);
  }

  // Cerrar (X, fondo, Esc) también lleva al pago: la meta es que llegue al checkout, no devolverlo al sitio.
  function closeModal(reason) {
    if (!state.open) return;
    setDismissed();
    track('close', { fs_reason: reason, fs_added: state.added.length });
    hideModal();
    logAttr('cerró' + (state.added.length ? ' tras agregar' : ' sin agregar')).then(() => go(state.destination));
  }

  function hideModal() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('paws-fs-open');
    state.open = false;
  }
  // Siempre ocultar ANTES de navegar: si el usuario vuelve con "atrás", el navegador restaura la página
  // desde su caché (bfcache) tal como estaba, y no debe quedar la ventana abierta.
  function go(destination) { hideModal(); window.location.href = destination || '/checkout'; }
  window.addEventListener('pageshow', (ev) => { if (ev.persisted || dismissed()) hideModal(); });

  /* Decide: abre la ventana o navega directo. Devuelve true si la abrió. */
  async function gate(destination) {
    destination = destination || '/checkout';
    if (dismissed()) { go(destination); return false; }
    let cart;
    try { cart = await getCart(); } catch (e) { go(destination); return false; }
    const total = cart.total_price || 0;
    if (!cart.item_count || total < MIN || total >= THRESHOLD) { go(destination); return false; }
    const plan = buildPlan(cart);
    if (plan.mode === 'reached' || !plan.rows.length || !plan.rows.every((r) => r.items.length)) { go(destination); return false; }
    openModal(cart, plan, destination);
    return true;
  }
  window.PAWS_FS_GATE = gate;

  /* ───────── eventos ───────── */
  root.querySelectorAll('[data-fs-close]').forEach((el) => el.addEventListener('click', () => closeModal('x')));
  document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape' && state.open) closeModal('esc'); });
  ctaEl.addEventListener('click', (ev) => { ev.preventDefault(); setDismissed(); track('checkout', { fs_added: state.added.length }); hideModal(); logAttr('ir al pago' + (state.added.length ? ' tras agregar' : ' sin agregar')).then(() => go(state.destination)); });
  skipEl.addEventListener('click', (ev) => { ev.preventDefault(); setDismissed(); track('skip'); hideModal(); logAttr('no gracias').then(() => go(state.destination)); });

  // Intercepta los botones de checkout (slide cart, página /cart, links a /checkout).
  document.addEventListener('click', (ev) => {
    if (state.open) return;
    const t = ev.target && ev.target.closest && ev.target.closest('[data-paws-cart-checkout], button[name="checkout"], a[href="/checkout"], a[href$="/checkout"]');
    if (!t || root.contains(t)) return;
    if (dismissed()) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (t.tagName === 'BUTTON') t.disabled = true;
    gate('/checkout').then((opened) => { if (!opened) return; if (t.tagName === 'BUTTON') t.disabled = false; });
  }, true);
})();
